require('./business-consultation.scss');

$(() => {
    // Your code here
});